// Trend helpers shared by the report KPI tiles and chart card headers.
// For average (time) metrics a decrease is an improvement; for counts an
// increase is an improvement.
export const getTrendTone = (trend, isAverageMetric = false) => {
  if (!trend) return 'neutral';

  const improved = isAverageMetric ? trend < 0 : trend > 0;
  return improved ? 'positive' : 'negative';
};

export const formatTrend = trend => {
  if (!trend) return '0%';
  return `${trend > 0 ? '+' : '−'}${Math.abs(trend)}%`;
};

export const TREND_TONE_CLASSES = {
  positive: 'bg-n-teal-3 text-n-teal-11',
  negative: 'bg-n-ruby-3 text-n-ruby-11',
  neutral: 'bg-n-alpha-2 text-n-slate-11',
};

export const METRIC_ICONS = {
  conversations_count: 'i-hugeicons-bubble-chat',
  incoming_messages_count: 'i-hugeicons-message-incoming-01',
  outgoing_messages_count: 'i-hugeicons-message-outgoing-01',
  avg_first_response_time: 'i-hugeicons-timer-01',
  avg_resolution_time: 'i-hugeicons-hourglass',
  resolutions_count: 'i-hugeicons-checkmark-circle-02',
  reply_time: 'i-hugeicons-clock-01',
  bot_resolutions_count: 'i-hugeicons-task-done-01',
  bot_handoffs_count: 'i-hugeicons-user-switch',
};

export const getMetricIcon = key =>
  METRIC_ICONS[key] || 'i-hugeicons-chart-column';
